// extracted by mini-css-extract-plugin
module.exports = {"ResultContainer":"Result_ResultContainer__vZdGa","RecommedationContent":"Result_RecommedationContent__7kvPe"};